import type { InjectionKey } from 'vue'

export const InjectionI18nTitle: InjectionKey<Function> = Symbol('i18nTitle')
